import * as React from 'react'

import { Link, NoticeBox } from '@factorialco/deprecated-design-system'
import moment from 'moment'

import { observer } from 'mobx-react'

import helpCenterUrl from 'modules/core/lib/helpCenterUrl'
import i18n from 'modules/core/lib/i18n'
import companies from 'modules/core/store/collections/companies'

const DeletionBanner = () => {
  const deletion = companies.selected?.deletion
  const endDate = moment(deletion!.access.revoke_at.toString())
  const now = moment()
  const dayCount = endDate.diff(now, 'days') + 1

  const deletionParams = {
    date: endDate.local().format('YYYY-MM-DD'),
    count: dayCount,
  }

  const message = (
    <Link.Href href={helpCenterUrl('company_deletion')} target="_blank" rel="noopener noreferrer">
      {i18n.t('common.cancel_company_subscription.banner.text', deletionParams)}
    </Link.Href>
  )

  return <NoticeBox message={message} justifyContent="center" alignItems="center" />
}

export default observer(DeletionBanner)
